import axios from 'axios';
import { ReadUserInfoResult } from '../models/readUserInfoResult';
import { Result } from '../models/result';
import { UpdateMailAddressResult } from '../models/updateMailAddressResult';
import { UpdatePasswordResult } from '../models/updatePasswordResult';
import Service from './service';

/**
 * ユーザーAPIを操作するクラスです。
 */
class UserService extends Service {
    /**
     * ユーザーの作成を行います。
     * @param accountName 作成するアカウント名を指定します。
     * @param mailAddress 作成するアカウントのメールアドレスを指定します。
     * @param password 作成するアカウントのパスワードを指定します。
     */
    public async createUser(accountName: string, mailAddress: string, password: string) {
        let message = '';
        const apiEndpoint = this.createApiEndpoint('create-user');;
        const params = {
            account_name: accountName,
            email: mailAddress,
            password: password,
        };

        try {
            await this.httpPost<Result>(apiEndpoint, params);
        } catch (reson: any) {
            console.error(reson);
            if (reson.message !== undefined) {
                message += this.checkUserCreateErrorMessage(reson.message);

                throw Error(message);
            }
        }
    }

    /**
     * ユーザー情報を取得します。
     * @param jwt JWTを指定します。
     * @returns ユーザー情報を返します。
     */
    public async getUser() {
        const apiEndpoint = this.createApiEndpoint('read-user-info');
        const jwt = sessionStorage.getItem('jwt');

        let result: ReadUserInfoResult | null = null;

        try {
            const response = await axios.get<ReadUserInfoResult>(apiEndpoint,
                {
                    params: {
                        jwt_str: jwt
                    }
                });

            if (response.status === 200) {
                result = response.data;
            }
        } catch (reson) {
            console.error(reson);
        }

        return result;
    }

    /**
     * メールアドレスの更新を行います。
     * @param mailAddress 更新するメールアドレスを指定します。
     * @param password パスワードを指定します。
     * @returns メールアドレス更新結果を返します。
     */
    public async updateMailAddress(mailAddress: string, password: string) {
        const apiEndpoint = this.createApiEndpoint('update-email');
        const jwt = sessionStorage.getItem('jwt');

        let result: UpdateMailAddressResult | null = null;

        try {
            const response = await axios.post<UpdateMailAddressResult>(apiEndpoint, {
                params: {
                    jwt_str: jwt,
                    email: mailAddress,
                    passowrd: password
                }
            });

            if (response.status === 200) {
                result = response.data;
            }
        } catch (reson) {
            console.error(reson);
        }

        return result;
    }

    /**
     * パスワードの更新を行います。
     * @param newPassword 新パスワードを指定します。
     * @param oldPassword 旧パスワードを指定します。
     * @returns パスワード更新結果を返します。
     */
    public async updatePassword(newPassword: string, oldPassword: string) {
        const apiEndpoint = this.createApiEndpoint('update-password');
        const jwt = sessionStorage.getItem('jwt');
        let result: UpdatePasswordResult | null = null;

        try {
            const response = await axios.post<UpdatePasswordResult>(apiEndpoint, {
                params: {
                    jwt_str: jwt,
                    old_password: oldPassword,
                    new_password: newPassword
                }
            });

            if (response.status === 200) {
                result = response.data;
            }
        } catch (reson) {
            console.error(reson);
        }

        return result;
    }

    /**
     * ユーザー作成時のエラーメッセージを生成します。
     * @param detail ユーザー作成結果を指定します。
     * @returns エラーメッセージを返します。
     */
    private checkUserCreateErrorMessage(detail: string) {
        let ret = '';
        Object.keys(this.errorMessageList).forEach((key) => {
            const errorMessageRegex = new RegExp(key);

            if (errorMessageRegex.test(detail)) {
                ret = this.errorMessageList[key];
            }
        });

        return ret;
    }



}

export default UserService